import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "budget-summary" }
const _hoisted_3 = { class: "summary-item" }
const _hoisted_4 = { class: "summary-label" }
const _hoisted_5 = { class: "summary-value" }
const _hoisted_6 = {
  key: 0,
  class: "offered-inline"
}
const _hoisted_7 = { class: "summary-item" }
const _hoisted_8 = { class: "summary-label" }
const _hoisted_9 = { class: "summary-value" }
const _hoisted_10 = { class: "summary-item" }
const _hoisted_11 = { class: "summary-label" }
const _hoisted_12 = { class: "summary-value" }
const _hoisted_13 = { class: "summary-item" }
const _hoisted_14 = { class: "summary-label" }
const _hoisted_15 = { class: "summary-helper" }
const _hoisted_16 = { class: "action-buttons" }
const _hoisted_17 = ["disabled", "title"]
const _hoisted_18 = {
  key: 0,
  class: "save-warning"
}
const _hoisted_19 = { class: "monthly-budgets-chart" }
const _hoisted_20 = { class: "chart-header" }
const _hoisted_21 = { class: "navigation-buttons" }
const _hoisted_22 = ["title"]
const _hoisted_23 = ["title"]
const _hoisted_24 = ["title"]
const _hoisted_25 = {
  key: 0,
  class: "loading"
}
const _hoisted_26 = {
  key: 1,
  class: "chart-container"
}
const _hoisted_27 = { class: "bars-container" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "bar-values" }
const _hoisted_30 = { class: "bar-value allocation-value" }
const _hoisted_31 = { class: "bar-value timesheet-value" }
const _hoisted_32 = { class: "bars-group" }
const _hoisted_33 = { class: "bar-column allocation-column" }
const _hoisted_34 = { class: "bar-column timesheet-column" }
const _hoisted_35 = { class: "bar-label" }
const _hoisted_36 = ["title", "onClick"]
const _hoisted_37 = {
  key: 0,
  class: "past-info"
}
const _hoisted_38 = { key: 0 }
const _hoisted_39 = {
  key: 1,
  class: "editable-input"
}
const _hoisted_40 = ["value", "onInput"]
const _hoisted_41 = {
  key: 0,
  class: "validation-error"
}
const _hoisted_42 = ["onClick"]
const _hoisted_43 = {
  key: 2,
  class: "quick-helper"
}
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["disabled", "onClick"]
const _hoisted_46 = { class: "chart-legend" }
const _hoisted_47 = { class: "legend-item" }
const _hoisted_48 = { class: "legend-item" }
const _hoisted_49 = { class: "legend-item" }
const _hoisted_50 = { class: "employee-allocation-section" }
const _hoisted_51 = { class: "employee-header" }
const _hoisted_52 = ["value"]
const _hoisted_53 = {
  key: 0,
  class: "employee-summary"
}
const _hoisted_54 = { class: "summary-item" }
const _hoisted_55 = { class: "summary-label" }
const _hoisted_56 = { class: "summary-value" }
const _hoisted_57 = {
  key: 0,
  class: "offered-inline"
}
const _hoisted_58 = { class: "summary-item" }
const _hoisted_59 = { class: "summary-label" }
const _hoisted_60 = { class: "summary-value" }
const _hoisted_61 = { class: "summary-item" }
const _hoisted_62 = { class: "summary-label" }
const _hoisted_63 = { class: "summary-value unassigned-value" }
const _hoisted_64 = { class: "summary-item" }
const _hoisted_65 = { class: "summary-label" }
const _hoisted_66 = { class: "summary-value" }
const _hoisted_67 = {
  key: 1,
  class: "exceeds-warning"
}
const _hoisted_68 = {
  key: 2,
  class: "employee-list"
}
const _hoisted_69 = { class: "employee-info" }
const _hoisted_70 = { class: "employee-name" }
const _hoisted_71 = { class: "employee-role" }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = { class: "employee-inputs" }
const _hoisted_74 = { class: "input-group" }
const _hoisted_75 = ["value", "onInput"]
const _hoisted_76 = {
  key: 1,
  class: "readonly-value"
}
const _hoisted_77 = { class: "input-group" }
const _hoisted_78 = ["value", "onInput"]
const _hoisted_79 = {
  key: 1,
  class: "readonly-value"
}
const _hoisted_80 = { class: "employee-stats" }
const _hoisted_81 = { class: "employee-bar" }
const _hoisted_82 = { class: "progress-bar" }
const _hoisted_83 = { class: "progress-label" }
const _hoisted_84 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_85 = {
  key: 3,
  class: "employee-total"
}

import { computed, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useQuery, useMutation } from "@vue/apollo-composable";
import { GET_PROJECT_MONTHLY_BUDGETS } from "@/graphql/project/queries";
import { SAVE_PROJECT_DELIVERY_ALLOCATION } from "@/graphql/project/mutations";
import { formatPrice } from "@/helpers/utils";
import enUK from "@/locales/project/en-UK.json";

type MessageSchema = typeof enUK;

type EmployeeAllocation = {
  id?: string | null;
  projectMonthlyBudgetId?: string | null;
  userId: string;
  projectRoleId: string;
  userName: string;
  roleName?: string | null;
  hourlyRate: number;
  allocatedAmount: number;
  allocatedHours: number;
  timesheetAmount: number;
  timesheetHours: number;
  remainingAmount: number;
};

// Helper to create a unique key for user/role tuple
type MonthBudget = {
  id: string;
  projectId: string;
  month: string;
  allocatedAmount: number;
  timesheetAmount: number;
  offeredAmount: number;
  effectiveAmount: number;
  employeeAllocations?: EmployeeAllocation[];
};

type ProjectDeliveryBudget = {
  projectId: string;
  commercialBudgetAmount: number;
  totalOfferedAmount: number;
  allocatedAmount: number;
  effectiveAllocatedAmount: number;
  toAllocateAmount: number;
  months: MonthBudget[];
};


export default /*@__PURE__*/_defineComponent({
  __name: 'DeliveryManager',
  props: {
    id: {}
  },
  setup(__props: any) {

const { t } = useI18n<[MessageSchema], "en-UK">({
  useScope: "global",
  inheritLocale: true,
  messages: {
    "en-UK": enUK,
  },
});

const props = __props;

const getUserRoleKey = (userId: string, projectRoleId: string): string => {
  return `${userId}|${projectRoleId}`;
};

const monthOffset = ref(0);
const draftAllocations = ref<Record<string, number>>({});
const employeeDraftAllocations = ref<Record<string, Record<string, number>>>(
  {},
);
const selectedEmployeeMonth = ref<string>(getCurrentMonthStr());
const draftsInitialized = ref(false);

const { result: deliveryResult, loading } = useQuery(
  GET_PROJECT_MONTHLY_BUDGETS,
  computed(() => ({ projectId: props.id })),
  {
    fetchPolicy: "network-only",
  },
);

const { mutate: saveDeliveryAllocation, loading: saving } = useMutation(
  SAVE_PROJECT_DELIVERY_ALLOCATION,
);

const deliveryBudget = computed<ProjectDeliveryBudget | null>(() => {
  return deliveryResult.value?.projectMonthlyBudgets ?? null;
});

const allMonths = computed<MonthBudget[]>(() => {
  return deliveryBudget.value?.months ?? [];
});

// Computed property that merges backend months with months that have drafts
// This ensures we can edit/save any month, even if it's not in the backend response
const allMonthsData = computed<MonthBudget[]>(() => {
  const monthsMap = new Map<string, MonthBudget>();

  // Start with months from backend
  for (const m of allMonths.value) {
    monthsMap.set(m.month, m);
  }

  // Add months from draftAllocations that aren't in backend
  for (const monthKey of Object.keys(draftAllocations.value)) {
    if (!monthsMap.has(monthKey)) {
      monthsMap.set(monthKey, {
        id: `draft-${monthKey}`,
        projectId: props.id,
        month: monthKey,
        allocatedAmount: draftAllocations.value[monthKey] ?? 0,
        timesheetAmount: 0,
        offeredAmount: 0,
        effectiveAmount: draftAllocations.value[monthKey] ?? 0,
        employeeAllocations: [],
      });
    }
  }

  // Add months from employeeDraftAllocations that aren't already included
  for (const monthKey of Object.keys(employeeDraftAllocations.value)) {
    if (!monthsMap.has(monthKey)) {
      monthsMap.set(monthKey, {
        id: `draft-${monthKey}`,
        projectId: props.id,
        month: monthKey,
        allocatedAmount: draftAllocations.value[monthKey] ?? 0,
        timesheetAmount: 0,
        offeredAmount: 0,
        effectiveAmount: draftAllocations.value[monthKey] ?? 0,
        employeeAllocations: [],
      });
    }
  }

  return Array.from(monthsMap.values()).sort((a, b) =>
    a.month.localeCompare(b.month),
  );
});

const commercialBudgetAmount = computed(() => {
  return deliveryBudget.value?.commercialBudgetAmount ?? 0;
});

const totalOfferedAmount = computed(() => {
  return deliveryBudget.value?.totalOfferedAmount ?? 0;
});

watch(
  () => deliveryBudget.value,
  (budget) => {
    if (budget && !draftsInitialized.value) {
      syncDraftsFromBudget(budget);
      draftsInitialized.value = true;
    }
  },
  { immediate: true },
);

function syncDraftsFromBudget(budget: ProjectDeliveryBudget): void {
  const newDrafts: Record<string, number> = {};
  const newEmpDrafts: Record<string, Record<string, number>> = {};

  for (const m of budget.months) {
    newDrafts[m.month] = m.allocatedAmount;

    const empDrafts: Record<string, number> = {};
    for (const emp of m.employeeAllocations ?? []) {
      const key = getUserRoleKey(emp.userId, emp.projectRoleId);
      empDrafts[key] = emp.allocatedAmount;
    }

    newEmpDrafts[m.month] = empDrafts;
  }

  console.log("[DeliveryManager] Syncing drafts from budget", {
    months: budget.months.map((m) => ({
      month: m.month,
      allocatedAmount: m.allocatedAmount,
      employeeAllocations: (m.employeeAllocations ?? []).map((emp) => ({
        userId: emp.userId,
        projectRoleId: emp.projectRoleId,
        userName: emp.userName,
        allocatedAmount: emp.allocatedAmount,
      })),
    })),
  });

  draftAllocations.value = newDrafts;
  employeeDraftAllocations.value = newEmpDrafts;
}

function getCurrentMonthStr(): string {
  const now = new Date();
  const year = now.getFullYear();
  const month = `${now.getMonth() + 1}`.padStart(2, "0");

  return `${year}-${month}-01`;
}

const isPastMonth = (monthStr: string): boolean => {
  const now = new Date();
  const currentMonthStart = new Date(now.getFullYear(), now.getMonth(), 1);
  const monthDate = new Date(monthStr);

  return monthDate < currentMonthStart;
};

const isCurrentOrFuture = (monthStr: string): boolean => {
  return !isPastMonth(monthStr);
};

const getEffectiveAmount = (month: MonthBudget): number => {
  if (isPastMonth(month.month)) {
    return month.timesheetAmount;
  }

  const draft = draftAllocations.value[month.month] ?? month.allocatedAmount;
  const offered = month.offeredAmount ?? 0;

  return Math.max(draft + offered, month.timesheetAmount);
};

const effectiveAllocatedAmount = computed(() => {
  return allMonthsData.value.reduce((sum, m) => {
    return sum + getEffectiveAmount(m);
  }, 0);
});

const toAllocateAmount = computed(() => {
  return (
    commercialBudgetAmount.value +
    totalOfferedAmount.value -
    effectiveAllocatedAmount.value
  );
});

const allocatedAmount = computed(() => {
  return allMonthsData.value.reduce((sum, m) => {
    return sum + (draftAllocations.value[m.month] ?? m.allocatedAmount);
  }, 0);
});

const visibleMonthKeys = computed(() => {
  const now = new Date();
  const keys: string[] = [];

  for (let i = 0; i < 7; i++) {
    const date = new Date(
      now.getFullYear(),
      now.getMonth() + monthOffset.value + i,
      1,
    );

    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, "0");

    keys.push(`${year}-${month}-01`);
  }

  return keys;
});

const monthLabels = computed(() => {
  const now = new Date();
  const labels: string[] = [];
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  for (let i = 0; i < 7; i++) {
    const date = new Date(
      now.getFullYear(),
      now.getMonth() + monthOffset.value + i,
      1,
    );

    labels.push(`${monthNames[date.getMonth()]} ${date.getFullYear()}`);
  }

  return labels;
});

const getMonthData = (index: number): MonthBudget | null => {
  const monthKey = visibleMonthKeys.value[index];

  return allMonthsData.value.find((m) => m.month === monthKey) ?? null;
};

const getDraftAllocation = (index: number): number => {
  const monthKey = visibleMonthKeys.value[index];
  const monthData = getMonthData(index);

  if (!monthData) {
    return 0;
  }

  return draftAllocations.value[monthKey] ?? monthData.allocatedAmount;
};

const setDraftAllocation = (index: number, value: number) => {
  const monthKey = visibleMonthKeys.value[index];

  draftAllocations.value = {
    ...draftAllocations.value,
    [monthKey]: value,
  };
};

const getMinimumAllocation = (monthData: MonthBudget): number => {
  return Math.max(
    monthData.timesheetAmount - (monthData.offeredAmount ?? 0),
    0,
  );
};

const isBelowTimesheet = (index: number): boolean => {
  const monthData = getMonthData(index);

  if (!monthData) {
    return false;
  }

  const draft = getDraftAllocation(index);
  const minimumAllocation = getMinimumAllocation(monthData);

  return draft < minimumAllocation;
};

const maxValue = computed(() => {
  let max = 0;

  for (let i = 0; i < 7; i++) {
    const monthData = getMonthData(i);

    if (monthData) {
      const draft = getDraftAllocation(i);

      // Allocation stack: draft + offered
      const allocationStack = draft + (monthData.offeredAmount ?? 0);
      if (allocationStack > max) {
        max = allocationStack;
      }

      if (monthData.timesheetAmount > max) {
        max = monthData.timesheetAmount;
      }
    }
  }

  return max || 1;
});

const goToPreviousMonth = () => {
  monthOffset.value--;
};

const goToNextMonth = () => {
  monthOffset.value++;
};

const goToCurrentMonth = () => {
  monthOffset.value = 0;
};

const toAllocateDisplay = computed(() => {
  const val = toAllocateAmount.value;

  if (val > 0) {
    return t("deliveryManager.summary.leftToAllocate", {
      amount: formatPrice(val),
    });
  }

  if (val === 0) {
    return t("deliveryManager.summary.balanced");
  }

  return t("deliveryManager.summary.overallocatedBy", {
    amount: formatPrice(Math.abs(val)),
  });
});

const toAllocateClass = computed(() => {
  const val = toAllocateAmount.value;

  if (val > 0) {
    return "to-allocate-positive";
  }

  if (val === 0) {
    return "to-allocate-balanced";
  }

  return "to-allocate-negative";
});

const monthValidation = computed(() => {
  return allMonthsData.value.map((m) => {
    const isPast = isPastMonth(m.month);
    const monthBudget = draftAllocations.value[m.month] ?? m.allocatedAmount;
    const availableMonthBudget = monthBudget + (m.offeredAmount ?? 0);
    const employees = m.employeeAllocations ?? [];

    const employeeAllocatedTotal = employees.reduce((sum, emp) => {
      const key = getUserRoleKey(emp.userId, emp.projectRoleId);
      return (
        sum +
        (employeeDraftAllocations.value[m.month]?.[key] ?? emp.allocatedAmount)
      );
    }, 0);

    const employeeBelowConsumed = employees.filter((emp) => {
      const key = getUserRoleKey(emp.userId, emp.projectRoleId);
      const draft =
        employeeDraftAllocations.value[m.month]?.[key] ?? emp.allocatedAmount;

      return !isPast && draft < emp.timesheetAmount;
    });

    const employeeOverBudget =
      !isPast && employeeAllocatedTotal > availableMonthBudget;
    const minimumMonthBudget = Math.max(
      m.timesheetAmount - (m.offeredAmount ?? 0),
      0,
    );
    const monthBelowTimesheets = !isPast && monthBudget < minimumMonthBudget;

    return {
      month: m.month,
      isPast,
      monthBudget,
      availableMonthBudget,
      minimumMonthBudget,
      employeeAllocatedTotal,
      employeeOverBudget,
      employeeOverBudgetAmount: Math.max(
        employeeAllocatedTotal - availableMonthBudget,
        0,
      ),
      employeeBelowConsumed,
      monthBelowTimesheets,
      isValid:
        isPast ||
        (!employeeOverBudget &&
          employeeBelowConsumed.length === 0 &&
          !monthBelowTimesheets),
    };
  });
});

const invalidEmployeeMonths = computed(() => {
  return monthValidation.value.filter((m) => !m.isValid);
});

const monthsBelowTimesheets = computed(() => {
  return monthValidation.value.filter((m) => m.monthBelowTimesheets);
});

const canSave = computed(() => {
  return true;
});

const saveDisabledReason = computed(() => {
  if (toAllocateAmount.value < 0) {
    return t("deliveryManager.validation.cannotSaveOverallocated", {
      amount: formatPrice(Math.abs(toAllocateAmount.value)),
    });
  }

  if (invalidEmployeeMonths.value.length > 0) {
    return t("deliveryManager.validation.cannotSaveEmployeeIssues", {
      count: invalidEmployeeMonths.value.length,
    });
  }

  if (monthsBelowTimesheets.value.length > 0) {
    return t("deliveryManager.validation.cannotSaveBelowTimesheets");
  }

  return "";
});

const saveAllocation = async () => {
  if (!canSave.value || saving.value) {
    return;
  }

  const monthlyAllocations = allMonthsData.value.map((m) => {
    const employees = m.employeeAllocations ?? [];

    return {
      month: m.month,
      allocatedAmount: Math.round(
        draftAllocations.value[m.month] ?? m.allocatedAmount,
      ),
      employeeAllocations: employees.map((emp) => ({
        userId: emp.userId,
        projectRoleId: emp.projectRoleId,
        allocatedAmount: Math.round(
          employeeDraftAllocations.value[m.month]?.[
            getUserRoleKey(emp.userId, emp.projectRoleId)
          ] ?? emp.allocatedAmount,
        ),
      })),
    };
  });

  console.log("[DeliveryManager] Saving allocation payload", {
    projectId: props.id,
    monthlyAllocations,
  });

  try {
    const result = await saveDeliveryAllocation({
      input: {
        projectId: props.id,
        monthlyAllocations,
      },
    });

    console.log(
      "[DeliveryManager] Mutation result",
      result?.data?.saveProjectDeliveryAllocation,
    );

    const savedBudget = result?.data?.saveProjectDeliveryAllocation;

    if (savedBudget) {
      syncDraftsFromBudget(savedBudget);
      return;
    }

    console.warn(
      "[DeliveryManager] Save succeeded but no refreshed budget was found",
    );
  } catch (error) {
    console.error("[DeliveryManager] Save failed", error);
    alert(
      t("deliveryManager.validation.saveFailed", {
        message: (error as Error).message,
      }),
    );
  }
};

const reset = () => {
  if (!confirm(t("deliveryManager.validation.resetConfirm"))) {
    return;
  }

  if (deliveryBudget.value) {
    syncDraftsFromBudget(deliveryBudget.value);
  }
};

const distributeRemaining = () => {
  const remaining = Math.round(toAllocateAmount.value);

  if (remaining === 0) {
    return;
  }

  const editableMonths = allMonthsData.value.filter((m) =>
    isCurrentOrFuture(m.month),
  );

  if (editableMonths.length === 0) {
    return;
  }

  const drafts = { ...draftAllocations.value };
  let warning = false;

  if (remaining > 0) {
    // Calculate per-month amount in whole cents
    const perMonth = Math.floor(remaining / editableMonths.length);
    // Calculate the remaining cents to distribute to first month(s)
    const remainder = remaining - perMonth * editableMonths.length;

    for (let i = 0; i < editableMonths.length; i++) {
      const m = editableMonths[i];
      const current = Math.round(drafts[m.month] ?? m.allocatedAmount);
      // Add one extra cent to first month(s) to ensure total matches
      const extra = i < remainder ? 1 : 0;
      drafts[m.month] = current + perMonth + extra;
    }
  } else {
    let remainingToRemove = Math.abs(remaining);
    let removableMonths = editableMonths.map((m) => {
      const current = Math.round(drafts[m.month] ?? m.allocatedAmount);
      const minimumAllocation = Math.max(
        m.timesheetAmount - (m.offeredAmount ?? 0),
        0,
      );

      return {
        month: m.month,
        current,
        minimumAllocation,
      };
    });

    while (remainingToRemove > 0 && removableMonths.length > 0) {
      const perMonth = Math.floor(remainingToRemove / removableMonths.length);
      const remainder = remainingToRemove % removableMonths.length;
      let removedThisPass = 0;

      removableMonths = removableMonths.filter((m, i) => {
        const current = Math.round(drafts[m.month] ?? m.current);
        const maxRemovable = current - m.minimumAllocation;
        const target = perMonth + (i < remainder ? 1 : 0);
        const toRemove = Math.min(target, maxRemovable);

        drafts[m.month] = current - toRemove;
        remainingToRemove -= toRemove;
        removedThisPass += toRemove;

        return maxRemovable - toRemove > 0;
      });

      if (removedThisPass === 0) {
        break;
      }
    }

    if (remainingToRemove > 0) {
      warning = true;
    }
  }

  draftAllocations.value = drafts;

  if (warning) {
    alert(t("deliveryManager.validation.distributeWarning"));
  }
};

const addToMonth = (index: number) => {
  const monthKey = visibleMonthKeys.value[index];

  if (!isCurrentOrFuture(monthKey)) {
    return;
  }

  const current = getDraftAllocation(index);

  setDraftAllocation(index, current + toAllocateAmount.value);
};

const canRemoveFromMonth = (index: number): boolean => {
  const monthKey = visibleMonthKeys.value[index];

  if (!isCurrentOrFuture(monthKey)) {
    return false;
  }

  const current = getDraftAllocation(index);
  const monthData = getMonthData(index);
  const minimumAllocation = monthData ? getMinimumAllocation(monthData) : 0;

  return current - minimumAllocation >= Math.abs(toAllocateAmount.value);
};

const removeFromMonth = (index: number) => {
  const monthKey = visibleMonthKeys.value[index];

  if (!isCurrentOrFuture(monthKey)) {
    return;
  }

  if (!canRemoveFromMonth(index)) {
    return;
  }

  const current = getDraftAllocation(index);

  setDraftAllocation(index, current + toAllocateAmount.value);
};

const setToConsumed = (index: number) => {
  const monthData = getMonthData(index);

  if (!monthData) {
    return;
  }

  const minimumAllocation = getMinimumAllocation(monthData);
  setDraftAllocation(index, minimumAllocation);
};

const barHeight = (value: number): string => {
  if (value === 0) {
    return "0%";
  }

  return `${(value / maxValue.value) * 100}%`;
};

const selectedMonthData = computed(() => {
  return (
    allMonthsData.value.find((m) => m.month === selectedEmployeeMonth.value) ??
    null
  );
});

const getEmployeeDraftAllocation = (
  userId: string,
  projectRoleId: string,
): number => {
  const monthDrafts =
    employeeDraftAllocations.value[selectedEmployeeMonth.value];

  if (!monthDrafts) {
    return 0;
  }

  const key = getUserRoleKey(userId, projectRoleId);
  return monthDrafts[key] ?? 0;
};

const setEmployeeDraftAllocation = (
  userId: string,
  projectRoleId: string,
  amount: number,
) => {
  const monthKey = selectedEmployeeMonth.value;
  const monthDrafts = { ...(employeeDraftAllocations.value[monthKey] ?? {}) };

  const key = getUserRoleKey(userId, projectRoleId);
  monthDrafts[key] = amount;

  employeeDraftAllocations.value = {
    ...employeeDraftAllocations.value,
    [monthKey]: monthDrafts,
  };
};

const selectedMonthEmployees = computed(() => {
  if (!selectedMonthData.value) {
    return [];
  }

  return (selectedMonthData.value.employeeAllocations ?? []).map((emp) => {
    const draftAmount = getEmployeeDraftAllocation(
      emp.userId,
      emp.projectRoleId,
    );

    return {
      ...emp,
      draftAllocatedAmount: draftAmount,
      draftAllocatedHours:
        emp.hourlyRate > 0 ? draftAmount / emp.hourlyRate : 0,
      remaining: draftAmount - emp.timesheetAmount,
    };
  });
});

const empMonthBudget = computed(() => {
  if (!selectedMonthData.value) {
    return 0;
  }

  const allocated =
    draftAllocations.value[selectedEmployeeMonth.value] ??
    selectedMonthData.value.allocatedAmount;

  return allocated + (selectedMonthData.value.offeredAmount ?? 0);
});

const allocatedToEmployees = computed(() => {
  return selectedMonthEmployees.value.reduce(
    (sum, emp) => sum + emp.draftAllocatedAmount,
    0,
  );
});

const unassigned = computed(() => {
  return empMonthBudget.value - allocatedToEmployees.value;
});

const consumed = computed(() => {
  return selectedMonthEmployees.value.reduce(
    (sum, emp) => sum + emp.timesheetAmount,
    0,
  );
});

const exceedsBudget = computed(() => {
  return allocatedToEmployees.value > empMonthBudget.value;
});

const exceedsBy = computed(() => {
  return allocatedToEmployees.value - empMonthBudget.value;
});

const selectMonthFromChart = (index: number) => {
  selectedEmployeeMonth.value = visibleMonthKeys.value[index];
};

const onEmployeeAmountInput = (
  userId: string,
  projectRoleId: string,
  event: Event,
) => {
  const euros = Number((event.target as HTMLInputElement).value);
  const cents = Math.round(euros * 100);

  setEmployeeDraftAllocation(userId, projectRoleId, cents);
};

const onEmployeeHoursInput = (
  userId: string,
  projectRoleId: string,
  hourlyRate: number,
  event: Event,
) => {
  const hours = Number((event.target as HTMLInputElement).value);
  const cents = Math.round(hours * hourlyRate);

  setEmployeeDraftAllocation(userId, projectRoleId, cents);
};

const setEmployeeToConsumed = (
  userId: string,
  projectRoleId: string,
  timesheetAmount: number,
) => {
  setEmployeeDraftAllocation(userId, projectRoleId, timesheetAmount);
};

const isEmployeeBelowConsumed = (emp: {
  draftAllocatedAmount: number;
  timesheetAmount: number;
}): boolean => {
  return (
    isCurrentOrFuture(selectedEmployeeMonth.value) &&
    emp.draftAllocatedAmount < emp.timesheetAmount
  );
};

const availableMonths = computed(() => {
  return allMonthsData.value.map((m) => m.month).sort();
});

const formatMonthLabel = (monthStr: string): string => {
  const date = new Date(monthStr);
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  return `${monthNames[date.getMonth()]} ${date.getFullYear()}`;
};

const getMonthValidation = (monthStr: string) => {
  return monthValidation.value.find((m) => m.month === monthStr);
};

const getMonthWarningTooltip = (monthStr: string): string => {
  const validation = getMonthValidation(monthStr);

  if (!validation || validation.isValid) {
    return "";
  }

  const issues: string[] = [];

  if (validation.employeeOverBudget) {
    issues.push(
      t("deliveryManager.validation.employeeOverBudget", {
        amount: formatPrice(validation.employeeOverBudgetAmount),
      }),
    );
  }

  for (const emp of validation.employeeBelowConsumed) {
    const key = getUserRoleKey(emp.userId, emp.projectRoleId);
    const draft =
      employeeDraftAllocations.value[monthStr]?.[key] ?? emp.allocatedAmount;

    const diff = emp.timesheetAmount - draft;

    issues.push(
      t("deliveryManager.validation.employeeBelowConsumed", {
        userName: emp.userName,
        amount: formatPrice(diff),
      }),
    );
  }

  if (validation.monthBelowTimesheets) {
    issues.push(t("deliveryManager.validation.monthBelowTimesheets"));
  }

  if (issues.length === 1) {
    return issues[0];
  }

  return `${t("deliveryManager.validation.multipleIssues", {
    count: issues.length,
  })}\n- ${issues.join("\n- ")}`;
};

const employeeBarWidth = (empAmount: number): string => {
  if (empMonthBudget.value <= 0) {
    return "0%";
  }

  return `${Math.min((empAmount / empMonthBudget.value) * 100, 100)}%`;
};

const employeeBarPercent = (empAmount: number): string => {
  if (empMonthBudget.value <= 0) {
    return "0";
  }

  return ((empAmount / empMonthBudget.value) * 100).toFixed(0);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)("deliveryManager.summary.orderBudget")), 1),
        _createElementVNode("span", _hoisted_5, [
          _createTextVNode(_toDisplayString(_unref(formatPrice)(commercialBudgetAmount.value)) + " ", 1),
          (totalOfferedAmount.value > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, " (+" + _toDisplayString(_unref(formatPrice)(totalOfferedAmount.value)) + ") ", 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)("deliveryManager.summary.allocatedBudget")), 1),
        _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(formatPrice)(allocatedAmount.value)), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)("deliveryManager.summary.effectiveAllocated")), 1),
        _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(formatPrice)(effectiveAllocatedAmount.value)), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(t)("deliveryManager.summary.toAllocate")), 1),
        _createElementVNode("span", {
          class: _normalizeClass(["summary-value", toAllocateClass.value])
        }, _toDisplayString(toAllocateDisplay.value), 3)
      ]),
      _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(t)("deliveryManager.summary.toAllocateHelper")), 1)
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("button", {
        class: "action-btn save-btn",
        disabled: !canSave.value || _unref(saving),
        title: canSave.value ? '' : saveDisabledReason.value,
        onClick: saveAllocation
      }, _toDisplayString(_unref(saving)
            ? _unref(t)("deliveryManager.actions.saving")
            : _unref(t)("deliveryManager.actions.saveAllocation")), 9, _hoisted_17),
      _createElementVNode("button", {
        class: "action-btn",
        onClick: reset
      }, _toDisplayString(_unref(t)("deliveryManager.actions.reset")), 1),
      _createElementVNode("button", {
        class: "action-btn",
        onClick: distributeRemaining
      }, _toDisplayString(_unref(t)("deliveryManager.actions.distributeRemaining")), 1),
      (saveDisabledReason.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(saveDisabledReason.value), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("h3", null, _toDisplayString(_unref(t)("deliveryManager.chart.title")), 1),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("button", {
            onClick: goToPreviousMonth,
            class: "nav-btn",
            title: _unref(t)('deliveryManager.chart.previousMonth')
          }, " ← ", 8, _hoisted_22),
          _createElementVNode("button", {
            onClick: goToCurrentMonth,
            class: "nav-btn current-btn",
            title: _unref(t)('deliveryManager.chart.currentMonth')
          }, _toDisplayString(_unref(t)("deliveryManager.chart.current")), 9, _hoisted_23),
          _createElementVNode("button", {
            onClick: goToNextMonth,
            class: "nav-btn",
            title: _unref(t)('deliveryManager.chart.nextMonth')
          }, " → ", 8, _hoisted_24)
        ])
      ]),
      (_unref(loading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_unref(t)("deliveryManager.chart.loading")), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(monthLabels.value, (label, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(["bar-wrapper", {
              'bar-selected': visibleMonthKeys.value[index] === selectedEmployeeMonth.value,
            }]),
                  onClick: ($event: any) => (selectMonthFromChart(index))
                }, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(formatPrice)(getDraftAllocation(index))), 1),
                    _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(formatPrice)(getMonthData(index)?.timesheetAmount ?? 0)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      (getMonthData(index)?.offeredAmount)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "bar offered-bar",
                            style: _normalizeStyle({
                    height: barHeight(getMonthData(index)?.offeredAmount ?? 0),
                  })
                          }, null, 4))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: _normalizeClass(["bar allocation-bar", {
                    'past-bar': isPastMonth(visibleMonthKeys.value[index]),
                    'has-offered': getMonthData(index)?.offeredAmount,
                  }]),
                        style: _normalizeStyle({ height: barHeight(getDraftAllocation(index)) })
                      }, null, 6)
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", {
                        class: "bar timesheet-bar",
                        style: _normalizeStyle({
                    height: barHeight(
                      getMonthData(index)?.timesheetAmount ?? 0,
                    ),
                  })
                      }, null, 4)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createTextVNode(_toDisplayString(label) + " ", 1),
                    (
                  getMonthValidation(visibleMonthKeys.value[index]) &&
                  !getMonthValidation(visibleMonthKeys.value[index])!.isValid
                )
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "month-warning-badge",
                          title: getMonthWarningTooltip(visibleMonthKeys.value[index]),
                          onClick: _withModifiers(($event: any) => (selectedEmployeeMonth.value = visibleMonthKeys.value[index]), ["stop"])
                        }, "⚠", 8, _hoisted_36))
                      : _createCommentVNode("", true)
                  ]),
                  (isPastMonth(visibleMonthKeys.value[index]) && getMonthData(index))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        _createElementVNode("div", null, _toDisplayString(_unref(t)("deliveryManager.chart.consumed")) + " " + _toDisplayString(_unref(formatPrice)(getMonthData(index)!.timesheetAmount)), 1),
                        (getMonthData(index)!.allocatedAmount > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_unref(t)("deliveryManager.chart.original")) + " " + _toDisplayString(_unref(formatPrice)(getMonthData(index)!.allocatedAmount)), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", null, _toDisplayString(_unref(t)("deliveryManager.chart.effective")) + " " + _toDisplayString(_unref(formatPrice)(getMonthData(index)!.timesheetAmount)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (isCurrentOrFuture(visibleMonthKeys.value[index]))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _createElementVNode("input", {
                          type: "number",
                          value: (getDraftAllocation(index) / 100).toFixed(2),
                          onInput: ($event: any) => (
                  setDraftAllocation(
                    index,
                    Math.round(
                      Number(($event.target as HTMLInputElement).value) * 100,
                    ),
                  )
                ),
                          class: _normalizeClass(["draft-input", { 'input-error': isBelowTimesheet(index) }]),
                          min: "0",
                          step: "1"
                        }, null, 42, _hoisted_40),
                        (isBelowTimesheet(index))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                              _createTextVNode(_toDisplayString(_unref(t)("deliveryManager.validation.allocationBelowConsumed", {
                    minimum: _unref(formatPrice)(
                      getMonthData(index)
                        ? getMinimumAllocation(getMonthData(index)!)
                        : 0,
                    ),
                  })) + " ", 1),
                              _createElementVNode("button", {
                                class: "quick-fix-btn",
                                onClick: ($event: any) => (setToConsumed(index))
                              }, _toDisplayString(_unref(t)("deliveryManager.actions.setToConsumed")), 9, _hoisted_42)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (
                isCurrentOrFuture(visibleMonthKeys.value[index]) &&
                toAllocateAmount.value !== 0
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                        (toAllocateAmount.value > 0)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "quick-action-btn",
                              onClick: ($event: any) => (addToMonth(index))
                            }, _toDisplayString(_unref(t)("deliveryManager.actions.addHere", {
                      amount: _unref(formatPrice)(toAllocateAmount.value),
                    })), 9, _hoisted_44))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "quick-action-btn remove-btn",
                              disabled: !canRemoveFromMonth(index),
                              onClick: ($event: any) => (removeFromMonth(index))
                            }, _toDisplayString(_unref(t)("deliveryManager.actions.removeHere", {
                      amount: _unref(formatPrice)(Math.abs(toAllocateAmount.value)),
                    })), 9, _hoisted_45))
                      ]))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_28))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "legend-color allocation-legend" }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_unref(t)("deliveryManager.chart.allocation")), 1)
              ]),
              _createElementVNode("div", _hoisted_48, [
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "legend-color timesheet-legend" }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_unref(t)("deliveryManager.chart.timesheetsConsumed")), 1)
              ]),
              _createElementVNode("div", _hoisted_49, [
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "legend-color offered-legend" }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_unref(t)("deliveryManager.chart.offered")), 1)
              ])
            ])
          ]))
    ]),
    _createElementVNode("div", _hoisted_50, [
      _createElementVNode("div", _hoisted_51, [
        _createElementVNode("h3", null, _toDisplayString(_unref(t)("deliveryManager.employee.title")), 1),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedEmployeeMonth).value = $event)),
          class: "month-selector"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableMonths.value, (month) => {
            return (_openBlock(), _createElementBlock("option", {
              key: month,
              value: month
            }, _toDisplayString(formatMonthLabel(month)), 9, _hoisted_52))
          }), 128))
        ], 512), [
          [_vModelSelect, selectedEmployeeMonth.value]
        ])
      ]),
      (selectedMonthData.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("span", _hoisted_55, _toDisplayString(_unref(t)("deliveryManager.employee.monthBudget")), 1),
              _createElementVNode("span", _hoisted_56, [
                _createTextVNode(_toDisplayString(_unref(formatPrice)(
                empMonthBudget.value - (selectedMonthData.value?.offeredAmount ?? 0),
              )) + " ", 1),
                (selectedMonthData.value?.offeredAmount)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_57, " (+" + _toDisplayString(_unref(formatPrice)(selectedMonthData.value.offeredAmount)) + ") ", 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("span", _hoisted_59, _toDisplayString(_unref(t)("deliveryManager.employee.allocatedToEmployees")), 1),
              _createElementVNode("span", _hoisted_60, _toDisplayString(_unref(formatPrice)(allocatedToEmployees.value)), 1)
            ]),
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("span", _hoisted_62, _toDisplayString(_unref(t)("deliveryManager.employee.unassigned")), 1),
              _createElementVNode("span", _hoisted_63, _toDisplayString(_unref(formatPrice)(unassigned.value)), 1)
            ]),
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("span", _hoisted_65, _toDisplayString(_unref(t)("deliveryManager.employee.consumed")), 1),
              _createElementVNode("span", _hoisted_66, _toDisplayString(_unref(formatPrice)(consumed.value)), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (exceedsBudget.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_67, _toDisplayString(_unref(t)("deliveryManager.employee.exceedsBudget", {
            amount: _unref(formatPrice)(exceedsBy.value),
          })), 1))
        : _createCommentVNode("", true),
      (selectedMonthData.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedMonthEmployees.value, (emp) => {
              return (_openBlock(), _createElementBlock("div", {
                key: getUserRoleKey(emp.userId, emp.projectRoleId),
                class: "employee-row"
              }, [
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("div", _hoisted_70, _toDisplayString(emp.userName), 1),
                  _createElementVNode("div", _hoisted_71, _toDisplayString(emp.roleName) + " · " + _toDisplayString(_unref(formatPrice)(emp.hourlyRate)) + "/h ", 1)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["validation-error emp-validation", { 'emp-validation-hidden': !isEmployeeBelowConsumed(emp) }])
                }, [
                  (isEmployeeBelowConsumed(emp))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("span", null, _toDisplayString(_unref(t)("deliveryManager.validation.allocationBelowConsumed", {
                    minimum: _unref(formatPrice)(emp.timesheetAmount),
                  })), 1),
                        _createElementVNode("button", {
                          class: "quick-fix-btn",
                          onClick: ($event: any) => (
                  setEmployeeToConsumed(
                    emp.userId,
                    emp.projectRoleId,
                    emp.timesheetAmount,
                  )
                )
                        }, _toDisplayString(_unref(t)("deliveryManager.actions.setToConsumed")), 9, _hoisted_72)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("label", null, _toDisplayString(_unref(t)("deliveryManager.employee.budget")), 1),
                    (isCurrentOrFuture(selectedEmployeeMonth.value))
                      ? (_openBlock(), _createElementBlock("input", {
                          key: 0,
                          type: "number",
                          value: (emp.draftAllocatedAmount / 100).toFixed(2),
                          onInput: ($event: any) => (
                  onEmployeeAmountInput(emp.userId, emp.projectRoleId, $event)
                ),
                          class: _normalizeClass(["draft-input emp-input", { 'input-error': isEmployeeBelowConsumed(emp) }]),
                          min: "0",
                          step: "1"
                        }, null, 42, _hoisted_75))
                      : (_openBlock(), _createElementBlock("span", _hoisted_76, _toDisplayString(_unref(formatPrice)(emp.timesheetAmount)), 1))
                  ]),
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("label", null, _toDisplayString(_unref(t)("deliveryManager.employee.hours")), 1),
                    (isCurrentOrFuture(selectedEmployeeMonth.value))
                      ? (_openBlock(), _createElementBlock("input", {
                          key: 0,
                          type: "number",
                          value: 
                  emp.hourlyRate > 0
                    ? (emp.draftAllocatedAmount / emp.hourlyRate).toFixed(1)
                    : '0.0'
                ,
                          onInput: ($event: any) => (
                  onEmployeeHoursInput(
                    emp.userId,
                    emp.projectRoleId,
                    emp.hourlyRate,
                    $event,
                  )
                ),
                          class: _normalizeClass(["draft-input emp-input hours-input", { 'input-error': isEmployeeBelowConsumed(emp) }]),
                          min: "0",
                          step: "0.5"
                        }, null, 42, _hoisted_78))
                      : (_openBlock(), _createElementBlock("span", _hoisted_79, _toDisplayString(emp.hourlyRate > 0 ? emp.timesheetHours.toFixed(1) : "0.0") + " h", 1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("div", null, _toDisplayString(_unref(t)("deliveryManager.employee.consumed")) + " " + _toDisplayString(_unref(formatPrice)(emp.timesheetAmount)), 1),
                  _createElementVNode("div", {
                    class: _normalizeClass({ negative: emp.remaining < 0 })
                  }, _toDisplayString(_unref(t)("deliveryManager.employee.remaining")) + " " + _toDisplayString(_unref(formatPrice)(emp.remaining)), 3)
                ]),
                _createElementVNode("div", _hoisted_81, [
                  _createElementVNode("div", _hoisted_82, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["progress-fill", {
                  'over-budget': emp.draftAllocatedAmount > empMonthBudget.value,
                }]),
                      style: _normalizeStyle({ width: employeeBarWidth(emp.draftAllocatedAmount) })
                    }, null, 6)
                  ]),
                  _createElementVNode("span", _hoisted_83, _toDisplayString(employeeBarPercent(emp.draftAllocatedAmount)) + "%", 1)
                ])
              ]))
            }), 128)),
            (selectedMonthEmployees.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_84, _toDisplayString(_unref(t)("deliveryManager.employee.noEmployees")), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (selectedMonthData.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)("deliveryManager.employee.totalAllocated", {
            allocated: _unref(formatPrice)(allocatedToEmployees.value),
            budget: _unref(formatPrice)(empMonthBudget.value),
          })), 1),
            _createElementVNode("span", null, _toDisplayString(_unref(t)("deliveryManager.employee.unassigned")) + ": " + _toDisplayString(_unref(formatPrice)(unassigned.value)), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})